const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Aarushi Sharma</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate PR Head, UPES-CSI</li>
    <li>
        Managing public relations and outreach initiatives.
    </li>
    <li>
        Building strong connections with partners and stakeholders.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
